import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { AirbnbCreateAlterationDialogComponent } from './airbnb-create-alteration-dialog.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable()
export class AirbnbCreateAlterationDialogService {
  constructor(private dialog: DialogService) {}

  open(inquiry: Inquiry) {
    let defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      data: { inquiry },
    }

    return this.dialog.openFixedDialog(AirbnbCreateAlterationDialogComponent, defaultConfig)
  }
}
